import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {
  ListCategoryMappingResponse
} from "it/primatoo/openapi/api/org/schemas/categorymapping/ListCategoryMappingResponse";
import {
  UpdateCategoryMappingRequest
} from "it/primatoo/openapi/api/org/schemas/categorymapping/UpdateCategoryMappingRequest";

@Injectable({
  providedIn: 'root'
})
export class CategoryMappingService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient) {
    this.endpoint = this.config.endPoint + '/api/org/v2/category-mappings/';
  }

  public findAll(): Observable<ListCategoryMappingResponse> {
    const url = this.endpoint;
    return this.httpClient.get<ListCategoryMappingResponse>(url);
  }

  public updateActivePermission(id: number, request: UpdateCategoryMappingRequest): Observable<void> {
    const url = this.endpoint;
    return this.httpClient.put<void>(url, request);
  }

}
